import { getData, postData } from '@/utils/http'
import config from '@/config'
export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: [],

		//查询条件
		pageIndex: 1,
		total: 0,
		projectId: '',
		orderDate: "",
		orderId: '',
		dispatchId: '',
		status: '',
		year: '',
		month: '',
		day: '',
		status: '',
		code: '',
		deptId: "",
		carNo:"",
		driver:"",
		completeTime:"",
		update:"",

		//收起展开
		isExpanded:true,

		//查询条件中的开始日期
		startTimer:"",
		dateType:1
	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading
		},
		CHANGE_ADD_LOADING(state, addLoading) {
			state.addLoading = addLoading
		},
		CHANGE_TABLE_DATA(state, changeData) {
			state.tableList = changeData.data.rows
			state.total = changeData.total
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
				state[changeData['changeKey']] = [changeData['data']]
			} else {
				state[changeData['changeKey']] = changeData['data']
			}
		},
		CHANGE_TABLE_INDEX(state, value) {
			state.pageIndex = value
		}
	},
	actions: {
		//获取运单列表
		getList({ commit, state }) {
			return new Promise(resolve => {
				getData(`logistics/waybill/page`, {
					projectId: state.projectId,
					orderId: state.orderId,
					dispatchId: state.dispatchId,
					status: state.status,
					page: state.pageIndex,
					size: config.pageSize,
					year:state.year,
					month:state.month,
					carNo:state.carNo,
					driver:state.driver,
					day:state.day,
					code:state.code,
					completeTime:state.completeTime,
					update:state.update
				}).then(res => {
					if (res.state == 1) {
						commit('CHANGE_TABLE_DATA', res)
						resolve({
							state: 1,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},
		//根据查询时候导出数据
		getExportData({ commit, state },total){
			return new Promise(resolve => {
				getData(`logistics/waybill/page`, {
					projectId: state.projectId,
					orderId: state.orderId,
					dispatchId: state.dispatchId,
					status: state.status,
					page: state.pageIndex,
					size:total,
					year:state.year,
					month:state.month,
					carNo:state.carNo,
					driver:state.driver,
					day:state.day,
					code:state.code,
					completeTime:state.completeTime
				}).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data:res.data.rows,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data:[],
							msg: res.msg
						})
					}
				})
			})
		},



		//获取我的项目列表
		getMyProjectList({ commit, state }, deptId) {
			return new Promise(resolve => {
				getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		},





		//获取对应订单列表
		getMyOrderList({ commit, state }) {
			const query = {
				projectId: state.projectId,
				page: 1,
				size: 9999,
				status: 0
			}
			return new Promise(resolve => {
				getData(`logistics/order/page`, query).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		},
		//获取对应调度列表
		getMyDispatchList({ commit, state }) {
			const query = {
				projectId: state.projectId,
				page: state.pageIndex,
				size: config.pageSize,
				status: 0
			}
			return new Promise(resolve => {
				getData(`logistics/order/page`, query).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		},
		//获取订单详情
		getIinfoById({ commit, state }) {
			return new Promise(resolve => {
				if (state.orderId) {
					getData(`logistics/order/get/${state.orderId}`).then(res => {
						if (res.state == 1) {
							resolve({
								state: 1,
								data: res.data,
								msg: '操作成功'
							})
						} else {
							resolve({
								state: 0,
								data: null,
								msg: res.msg
							})
						}
					})
				} else {
					resolve({
						state: 0,
						data: null,
						msg: "暂无数据"
					})
				}

			})
		},

		//获取运单详情
		getWaybillDetails({ commit, state }) {
			return new Promise(resolve => {
				getData(`logistics/waybill/details/${state.activeItem.id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},
		//修改运单
		modifyWaybill({ commit, state }, query) {
			return new Promise(resolve => {
				postData(`logistics/waybill/update`, query).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		getAllowOrg({ commit, state }, year) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dept/get/list`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},

		//根据id获取运输轨迹
		getTrackById({ commit, state }) {
		    return new Promise((resolve) => {
				getData(`logistics/waybill/trajectory/list/${state.activeItem.id}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},

		//根据项目获取地图站点列表
		getMapSiteList({ commit, state }, projectId) {
			return new Promise(resolve => {
				getData(`logistics/station/list/${projectId}`).then((res)=>{
					if (res.state == 1){
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data	
						})
					}else{
						resolve({
							state: 0,
							data:[]
						})
					}
				});
			})
		},

		//写入当前操作条目
		setActiveItem({ commit }, item) {
			commit('CHANGE_ACTIVE_ITEM', item)
		},

		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit('CHANGE_SEARCH_COLL', changeData)
		},
		//修改分页
		setPageIndex({ commit }, value) {
			commit('CHANGE_TABLE_INDEX', value)
		},
		//修改添加loading
		changeAddLoading({ commit }, value) {
			commit('CHANGE_ADD_LOADING', value)
		},
		//修改添加loading
		changeListLoading({ commit }, value) {
			commit('CHANGE_TABLE_LOADING', value)
		}
	}
}
